import property from 'lodash/property';
import * as type from "./types";
import axios from "axios";

export const _setAddresses = (addresses : type.AddressType[] ) => {
    return {
        type: type.SET_ADDRESS,
        addresses: addresses
    }
}

export const _fetchAddressesFailed = () => {
    return {
        type: type.FETCH_FAILED
    };
}

export const _searchAddress = async (postCode: string) => {
    return new Promise<Array<type.AddressType>>((resolve, reject) => {
        const server = (process.env.REACT_APP_ENV  === 'dev' ? process.env.REACT_APP_LOCAL_URL : '');
        axios.get(server + '/b2c-server/address/find/' + postCode + '/SGP', {
                params: {
                    handlerEnabled: false
                }
            })
            .then(resp => {
                resolve(resp.data);
            })
            .catch(error => {
                resolve();
            });
    })
}

export const getAddressesResult = property ( 'addr.addresses');
